export class Entsorger {
    entsorger_id: number;
    name: string;
    vvvo: string;
    favorit: number;
    kundenNrVvvos: KundenNrVvvo[] = [];
    email: string;
    telefon: string;
    mobil: string;
    fax: string;

    strasse: string;
    plz: string;
    ort: string;
}

export class KundenNrVvvo {
    constructor(kundeId: number, kundenNr: number, vvvo?: string, betrieb?: string, betrieb_zusatz?: string) {
        this.vvvo = vvvo;
        this.kunden_nr = kundenNr;
        this.kunde_id = kundeId;
        this.betrieb = betrieb;
        this.betrieb_zusatz = betrieb_zusatz;
    }

    vvvo: string;
    kunden_nr: number;
    kunde_id: number;
    // Temporaeres Feld fuers Frontend
    betrieb: string;
    // Temporaeres Feld fuers Frontend
    betrieb_zusatz: string;
}

/** Baut die VVVO-/Kundennummer-Liste aus allen Betrieben des Users (Profil → Betriebe). */
export function mergeKundenNrVvvosWithBetriebe(
    existing: KundenNrVvvo[] | null | undefined,
    betriebe: Array<{
        kunde_id?: number;
        vvvo?: string;
        bezeichnung_final?: string;
        bezeichnung?: string;
        zusatz_final?: string;
        zusatz?: string;
    }> | null | undefined,
): KundenNrVvvo[] {
    const existingByKundeId = new Map<number, KundenNrVvvo>();
    for (const entry of existing || []) {
        const kundeId = Number(entry?.kunde_id);
        if (kundeId > 0 && !existingByKundeId.has(kundeId)) {
            existingByKundeId.set(kundeId, entry);
        }
    }

    return (betriebe || [])
        .filter(b => Number(b?.kunde_id) > 0)
        .map(betrieb => {
            const kundeId = Number(betrieb.kunde_id);
            const prev = existingByKundeId.get(kundeId);
            const name = String(betrieb.bezeichnung_final || betrieb.bezeichnung || '').trim();
            const zusatz = String(betrieb.zusatz_final || betrieb.zusatz || '').trim();
            return new KundenNrVvvo(
                kundeId,
                prev?.kunden_nr ?? null,
                String(betrieb.vvvo || prev?.vvvo || '').trim() || null,
                name || null,
                zusatz || null,
            );
        })
        .sort((a, b) => {
            const byName = String(a.betrieb || '').localeCompare(String(b.betrieb || ''), 'de', {
                sensitivity: 'base',
            });
            if (byName !== 0) {
                return byName;
            }
            return Number(a.kunde_id) - Number(b.kunde_id);
        });
}
